'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var STATIC_PAGE = exports.STATIC_PAGE = {
    privacyPolicy: {
        displayName: 'privacy policy',
        resourceName: 'privacy-policy'
    },
    termsOfService: {
        displayName: 'terms of service',
        resourceName: 'terms-of-service'
    }
};

var URL_PREFIX = exports.URL_PREFIX = '/static/';


//////////////////
// WEBPACK FOOTER
// ./src/client/components/static/staticPageConstants.js
// module id = 442
// module chunks = 0